import * as React from 'react';
import { useEffect, useState } from 'react';

import ServiceHelper from 'stores/ServiceHelper';
import { Button, Row } from 'saladsoft-primitive';
import { useStoreWrapper } from 'stores/StoreHelper';
import { toast } from 'react-toastify';
import ItemBox from 'components/multiSelectContainer/ItemBox';
import { ItemType } from 'components/multiSelectContainer/types';

/**
 * 랜드마크 추가 페이지
 * @param checkedLandmarks 이미 선택된 랜드마크
 * @param listingId 시설 ID
 * @returns
 */
const ItemList = ({
  items,
  onSaveItems,
  style,
}: {
  items: ItemType[];
  onSaveItems: (items: ItemType[]) => void;
  style?: React.CSSProperties;
}) => {
  const { uiStore } = useStoreWrapper();

  const [candidates, setCandidates] = useState<ItemType[]>([]);

  const handleAddItem = (item: ItemType & { id: number }, checked: boolean) => {
    if (checked) {
      const isExist = candidates.some((o) => o.id === item.id);
      if (!isExist) {
        setCandidates([...candidates, item]);
      }
    } else {
      setCandidates(candidates.filter((o) => o.id !== item.id));
    }
  };

  const handleSave = () => {
    onSaveItems(candidates);
  };

  return (
    <div style={{ padding: 20, ...style }}>
      <div
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 20,
          color: 'var(--Grayscale-100, #727272)',
        }}
      >
        {items.length > 0
          ? `추가하실 항목을 선택하신 후, 하단의 저장 버튼을 눌러주세요.`
          : ` 추가할 항목이 없습니다.`}
      </div>
      <Row flexWrap="wrap" width="100%" justifyContent="flex-start" gap="10px">
        {items.map((item) => (
          <ItemBox
            key={item.id}
            item={item}
            onSelect={(item, checked) => handleAddItem(item as ItemType & { id: number }, checked)}
            checked={false}
          />
        ))}
      </Row>
      {items.length > 0 && (
        <Row justifyContent="flex-end" gap="10px" marginTop="50px">
          <Button type="outlined" onClick={() => uiStore?.modal.close()}>
            취소
          </Button>
          <Button onClick={handleSave} isValid={candidates.length > 0}>
            옵션 저장
          </Button>
        </Row>
      )}
    </div>
  );
};

export default ItemList;
